import React from "react";
import { useApp } from "context";
import { Custom, Form } from "components";
import { Enums } from "utils";
import { Box } from "@mui/material";
import { Feedback } from "types";
import { IAppointment } from "interfaces";

type Props = {
  onClick: (
    step: number,
    email?: string,
    patientId?: number,
    appointments?: IAppointment[]
  ) => void;
};

export const Email = (props: Props) => {
  const { setFeedback, t, theme } = useApp();

  const handleSubmit = (
    step: number,
    email: string,
    patientId: number,
    appointments: IAppointment[]
  ) => {
    if (step === Enums.EnumCheckInStep.WalkInNotAllowed) {
      setFeedback({
        message: t.message.qiosk.no_walkin_allowed,
        severity: Enums.EnumFeedback.Error,
      } as Feedback);
    } else if (step === Enums.EnumCheckInStep.MakeAppointment) {
      setFeedback({
        message: t.message.qiosk.check_in_with_account,
        severity: Enums.EnumFeedback.Success,
      } as Feedback);
    }
    props.onClick && props.onClick(step, email, patientId, appointments);
  };

  // const handleHome = () =>
  //   props.onClick && props.onClick(Enums.EnumCheckInStep.Home);

  return (
    <Box
      sx={{
        width: "80%",
        display: "flex",
        alignItems: "start",
        flexDirection: "column",
        // marginTop: -theme.margin.xl,
      }}
    >
      <>
        {/* <Custom.Button
          variant="outlined"
          sx={{
            fontSize: theme.font.sm,
            marginBottom: theme.margin.xl,
          }}
          onClick={handleHome}
        >
          {t.action.return_check_in}
        </Custom.Button> */}
        <Form.QioskEmail onSubmit={handleSubmit} />
      </>
    </Box>
  );
};
